import { useState } from "react";

import { Button, TextField, Typography } from "@mui/material";
import classNames from "classnames";

import { useMyCourseInstructor } from "../../hooks/useMyCourseInstructor";
import { Loading } from "../../../../common/Loading/Loading";

type TCreateLessonFormProps = {
	isFirst?: boolean;
	order: number;
	onClickCancel?: () => void;
	closeForm?: () => void;
};

export function CreateLessonForm({
	isFirst = false,
	order,
	onClickCancel,
	closeForm,
}: TCreateLessonFormProps) {
	const { createLesson } = useMyCourseInstructor();
	const [lessonName, setLessonName] = useState("");
	const [lessonNameError, setLessonNameError] = useState("");
	const [loading, setLoading] = useState(false);

	const onClickCancelCreateLesson = () => {
		setLessonName("");
		setLessonNameError("");
		onClickCancel?.();
	};

	const onClickCreateLesson = async () => {
		if (isDisabled) {
			return;
		}

		setLoading(true);
		await createLesson(lessonName, order);
		setLoading(false);
		closeForm?.();
	};

	let placeholder = "Your class name";
	if (isFirst) {
		placeholder = "Name your first class";
	}

	const isDisabled = lessonName.trim().length === 0 || !!lessonNameError;

	return (
		<div className="create-lesson-container item-separator-small">
			<div className="common-input">
				<TextField
					size="small"
					autoComplete="off"
					id="course-name"
					onChange={(e) => {
						setLessonName(e.target.value);
						if (e.target.value.trim() === "") {
							setLessonNameError("Class name is required.");
						} else {
							setLessonNameError("");
						}
					}}
					className={classNames("", {
						invalid: !!lessonNameError,
					})}
					value={lessonName}
					fullWidth
					placeholder={placeholder}
					slotProps={{
						input: {
							className: "normal-text",
							classes: {
								input: "input-placeholder",
							},
						},
					}}
				/>
				{lessonNameError && (
					<Typography className="small-text invalid-message">
						{lessonNameError}
					</Typography>
				)}
			</div>
			<div className="button-container item-separator-small">
				{!isFirst && (
					<Button
						className="normal-button disabled-button"
						onClick={onClickCancelCreateLesson}>
						Cancel
					</Button>
				)}
				<Button
					className={classNames("normal-button", {
						"primary-button": !isDisabled,
						"disabled-button": isDisabled,
					})}
					disabled={isDisabled}
					onClick={onClickCreateLesson}>
					Create
				</Button>
			</div>
			{loading && <Loading absolute />}
		</div>
	);
}
